import React, { useState, useEffect } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import { useDispatch, useSelector } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { ReactComponent as LastRecognition } from "assets/img/icons/last-recognition.svg";

export default () => {
  const dispatch = useDispatch();
  const { latestRecognition } = useSelector((state) => state.timelineReducer);
  const [loading, setLoading] = useState(false);
  const { teamId } = useTeamActionContext();
  const loadingStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    if (latestRecognition) {
      return;
    }

    (async () => {
      setLoading(true);
      try {
        var response = await TeamService.latestRecognition(teamId);
        dispatch(timelineActions.getLatestRecognition(response.data.data));
        // setLatestRecognition(response.data.data);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    })();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {loading && (
        <div style={loadingStyle}>
          <Loader width={40} height={40} />
        </div>
      )}
      {!loading && latestRecognition && (
        <div className="mainRecognition">
          <div className="latestRecognititonRoot">
            <div className="leftContent">
              <div className="recognizedContent">
                <span className="heading">Recognized</span>
                <span>
                  {latestRecognition?.data?.tagged_users.map((user, index) => (
                    <React.Fragment key={user.id}>
                      <span>{user.full_name}</span>
                      {latestRecognition?.data?.tagged_users.length - 1 !==
                        index && <span>, </span>}
                    </React.Fragment>
                  ))}
                </span>
              </div>
              <div className="recognizerContent">
                <span className="heading">Recognizer</span>
                <span>{latestRecognition?.user?.full_name}</span>
              </div>
            </div>
            <div className="rightContent">
              <span className="rightHeading">{`Last Team Recognition ${latestRecognition?.team.name}`}</span>
              <LastRecognition />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
